import React from "react";

import { Card, CardHeader, CardTitle, DefinitionList } from "../../styles";
import { formatObservedAt } from "../../utils/format";
import { ResolvedRequestDetailProps } from "../types";
import { decisionLabelOf } from "../utils/toWorkItem";

export const ResolvedRequestDetail: React.FC<ResolvedRequestDetailProps> = ({
  resolution: {
    request,
    decision,
    instrumentLabel,
    reason,
    warning,
    resolvedAt,
  },
}) => {
  const decisionLabel = decisionLabelOf(decision);

  return (
    <Card aria-label={`Decision on ${request.symbol}`}>
      <CardHeader>
        <CardTitle>{request.symbol}</CardTitle>
      </CardHeader>
      <DefinitionList>
        <dt>Decision</dt>
        <dd>{decisionLabel}</dd>
        {instrumentLabel && (
          <>
            <dt>Instrument</dt>
            <dd>{instrumentLabel}</dd>
          </>
        )}
        {reason && (
          <>
            <dt>Reason</dt>
            <dd>{reason}</dd>
          </>
        )}
        {warning && (
          <>
            <dt>Warning</dt>
            <dd>{warning}</dd>
          </>
        )}
        <dt>Requested exchange</dt>
        <dd>{request.exchangeLabel}</dd>
        <dt>Requesters</dt>
        <dd>{request.requesterCount}</dd>
        <dt>Decided</dt>
        <dd>{formatObservedAt(resolvedAt)}</dd>
      </DefinitionList>
    </Card>
  );
};
